/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === 'string';
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-custom-scrollbars/lib/utils/isString.js
 ** module id = 1604
 ** module chunks = 0
 **/